import BoostPolicyFlow from './BoostPolicyFlow';

const ONBOARDING_BASE_ROUTE = '/onboarding/boost-policy';

export const OnboardingBoostPolicyPage = () => (
  <BoostPolicyFlow
    baseRoute={ONBOARDING_BASE_ROUTE}
    isOnboarding={true}
  />
);
